export default __webpack_public_path__ + "static/media/V1.5f070f83.mp4";